import { render, staticRenderFns } from "./TheProductDetails.vue?vue&type=template&id=d6eaedd2&"
import script from "./TheProductDetails.vue?vue&type=script&lang=js&"
export * from "./TheProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6eaedd2')) {
      api.createRecord('d6eaedd2', component.options)
    } else {
      api.reload('d6eaedd2', component.options)
    }
    module.hot.accept("./TheProductDetails.vue?vue&type=template&id=d6eaedd2&", function () {
      api.rerender('d6eaedd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetails.vue"
export default component.exports